<template>
  <div class="index">
    <div class="yesterday-statics">
      <div class="yesterday">
        <img class="titleImg" :src="orderCount" alt="" />
        <span class="title">昨日订单数</span>
        <span class="num">{{ yesterdayOrder }}</span>
        <div class="pro1" v-if="yesterdayOrderCountYay < 0">
          <img :src="yay" alt="" />
          <span >同比：{{ Math.abs(yesterdayOrderCountYay) }}%</span>
        </div>
        <div class="pro1" v-else>
          <img :src="mam" alt="" />
          <span >同比：{{ Math.abs(yesterdayOrderCountYay) }}%</span>
        </div>
        <div class="pro2" v-if="yesterdayOrderCountMam < 0">
          <img :src="yay" alt="" />
          <span >环比：{{ Math.abs(yesterdayOrderCountMam) }}%</span>
        </div>
        <div class="pro2" v-else>
          <img :src="mam" alt="" />
          <span >环比：{{ Math.abs(yesterdayOrderCountMam) }}%</span>
        </div>
      </div>
      <div class="yesterday">
        <img class="titleImg" :src="orderSum" alt="" />
        <span class="title">昨日订单额</span>
        <span class="num">{{ yesterdayOrderMoneySum }}</span>
        <div class="pro1" v-if="yesterdayOrderMoneySumYay < 0">
          <img :src="yay" alt="" />
          <span >同比：{{ Math.abs(yesterdayOrderMoneySumYay) }}%</span>
        </div>
        <div class="pro1" v-else>
          <img :src="mam" alt="" />
          <span >同比：{{ Math.abs(yesterdayOrderMoneySumYay) }}%</span>
        </div>
        <div class="pro2" v-if="yesterdayOrderMoneySumMam < 0">
          <img :src="yay" alt="" />
          <span >环比：{{ Math.abs(yesterdayOrderMoneySumMam) }}%</span>
        </div>
        <div class="pro2" v-else>
          <img :src="mam" alt="" />
          <span >环比：{{ Math.abs(yesterdayOrderMoneySumMam) }}%</span>
        </div>
      </div>
      <div class="yesterday">
        <img class="titleImg" :src="orderRealPaySum" alt="" />
        <span class="title">昨日实付金额</span>
        <span class="num">{{ yesterdayOrderRealPayMoneySum }}</span>
        <div class="pro1" v-if="yesterdayOrderRealPayMoneySumYay < 0">
          <img :src="yay" alt="" />
          <span >同比：{{ Math.abs(yesterdayOrderRealPayMoneySumYay) }}%</span>
        </div>
        <div class="pro1" v-else>
          <img :src="mam" alt="" />
          <span >同比：{{ Math.abs(yesterdayOrderRealPayMoneySumYay) }}%</span>
        </div>
        <div class="pro2" v-if="yesterdayOrderRealPayMoneyMam < 0">
          <img :src="yay" alt="" />
          <span >环比：{{ Math.abs(yesterdayOrderRealPayMoneyMam) }}%</span>
        </div>
        <div class="pro2" v-else>
          <img :src="mam" alt="" />
          <span >环比：{{ Math.abs(yesterdayOrderRealPayMoneyMam) }}%</span>
        </div>
      </div>
      <div class="yesterday">
        <img class="titleImg" :src="nnOrderSum" alt="" />
        <span class="title">昨日99元订单</span>
        <span class="num">{{ yesterdayNinetyNineOrderCount }}</span>
        <div class="pro1" v-if="yesterdayNinetyNineOrderMoneySumYay < 0">
          <img :src="yay" alt="" />
          <span >同比：{{ Math.abs(yesterdayNinetyNineOrderMoneySumYay) }}%</span
          >
        </div>
        <div class="pro1" v-else>
          <img :src="mam" alt="" />
          <span >同比：{{ Math.abs(yesterdayNinetyNineOrderMoneySumYay) }}%</span
          >
        </div>
        <div class="pro2" v-if="yesterdayNinetyNineOrderCountMam < 0">
          <img :src="yay" alt="" />
          <span >环比：{{ Math.abs(yesterdayNinetyNineOrderCountMam) }}%</span>
        </div>
        <div class="pro2" v-else>
          <img :src="mam" alt="" />
          <span >环比：{{ Math.abs(yesterdayNinetyNineOrderCountMam) }}%</span>
        </div>
      </div>
      <div class="yesterday">
        <img class="titleImg" :src="refundSum" alt="" />
        <span class="title">昨日退款金额</span>
        <span class="num">{{ yesterdayRefundOrderMoneySum }}</span>
        <div class="pro1" v-if="yesterdayRefundOrderMoneySumYay < 0">
          <img :src="yay" alt="" />
          <span>同比：{{ Math.abs(yesterdayRefundOrderMoneySumYay) }}%</span>
        </div>
        <div class="pro1" v-else>
          <img :src="mam" alt="" />
          <span>同比：{{ Math.abs(yesterdayRefundOrderMoneySumYay) }}%</span>
        </div>
        <div class="pro2" v-if="yesterdayRefundOrderMoneySumMam < 0">
          <img :src="yay" alt="" />
          <span>环比：{{ Math.abs(yesterdayRefundOrderMoneySumMam) }}%</span>
        </div>
        <div class="pro2" v-else>
          <img :src="mam" alt="" />
          <span>环比：{{ Math.abs(yesterdayRefundOrderMoneySumMam) }}%</span>
        </div>
      </div>
      <div class="yesterday">
        <img class="titleImg" :src="refundCount" alt="" />
        <span class="title">昨日退款笔数</span>
        <span class="num">{{ yesterdayRefundOrderCount }}</span>
        <div class="pro1" v-if="yesterdayRefundOrderCountYay < 0">
          <img :src="yay" alt="" />
          <span>同比：{{ Math.abs(yesterdayRefundOrderCountYay) }}%</span>
        </div>
        <div class="pro1" v-else>
          <img :src="mam" alt="" />
          <span>同比：{{ Math.abs(yesterdayRefundOrderCountYay) }}%</span>
        </div>
        <div class="pro2" v-if="yesterdayRefundOrderCountMam < 0">
          <img :src="yay" alt="" />
          <span>环比：{{ Math.abs(yesterdayRefundOrderCountMam) }}%</span>
        </div>
        <div class="pro2" v-else>
          <img :src="mam" alt="" />
          <span>环比：{{ Math.abs(yesterdayRefundOrderCountMam) }}%</span>
        </div>
      </div>
      <div class="yesterday">
        <img class="titleImg" :src="discountSum" alt="" />
        <span class="title">昨日优惠金额</span>
        <span class="num">{{ yesterdayOrderDiscountMoneySum }}</span>
        <div class="pro1" v-if="yesterdayOrderDiscountMoneySumYay < 0">
          <img :src="yay" alt="" />
          <span>同比：{{ Math.abs(yesterdayOrderDiscountMoneySumYay) }}%</span>
        </div>
        <div class="pro1" v-else>
          <img :src="mam" alt="" />
          <span>同比：{{ Math.abs(yesterdayOrderDiscountMoneySumYay) }}%</span>
        </div>
        <div class="pro2" v-if="yesterdayOrderDiscountMoneySumMam < 0">
          <img :src="yay" alt="" />
          <span>环比：{{ Math.abs(yesterdayOrderDiscountMoneySumMam) }}%</span>
        </div>
        <div class="pro2" v-else>
          <img :src="mam" alt="" />
          <span>环比：{{ Math.abs(yesterdayOrderDiscountMoneySumMam) }}%</span>
        </div>
      </div>
      <div class="yesterday">
        <img class="titleImg" :src="onLine" alt="" />
        <span class="title">设备在线情况</span>
        <div style="margin-top: 33%; color: #0B2161;">
          <span style="font-size: 0.3rem">在线：{{ deviceOnLineCount }}</span>
          <span style="font-size: 0.3rem">离线：{{ deviceOffLineCount }}</span>
        </div>
      </div>
    </div>
    <div id="cumulativeStatics"></div>
    <div class="myEcharts">
      <div id="deviceDistribute"></div>
      <div id="inline"></div>
    </div>
  </div>
</template>
<script>
import { getIndexData, getChart } from "../../api/index/index.js";
import {sevenDays} from '../../utils/date.js'

let echarts = require("echarts/lib/echarts");
require("echarts/lib/chart/line");
require("echarts/lib/chart/pie")
require("echarts/lib/component/tooltip");
require("echarts/lib/component/title");
require("echarts/lib/component/legend");
export default {
  name: "Index",
  data() {
    return {
      reference: "",
      message: "",
      visible: false,
      date: "",
      orderCount: require("../../../static/image/index/dingdanshu.png"),
      orderSum: require("../../../static/image/index/dingdane.png"),
      mam: require("../../../static/image/index/shang-index.png"),
      yay: require("../../../static/image/index/xia-index.png"),
      orderRealPaySum: require("../../../static/image/index/shifue.png"),
      nnOrderSum: require("../../../static/image/index/99dingdan.png"),
      deviceDistribute: require("../../../static/image/index/leixing.png"),
      refundSum: require("../../../static/image/index/tuikuan.png"),
      refundCount: require("../../../static/image/index/tuikuanshu.png"),
      discountSum: require("../../../static/image/index/youhuie.png"),
      onLine: require("../../../static/image/index/zaixian.png"),
      onLinePro: require("../../../static/image/index/zaixianlv.png"),
      cumulativeStatic: require("../../../static/image/index/jine.png"),
      value1: "",
      wayOptions: [
        {
          value: "0",
          label: "天",
        },
        {
          value: "1",
          label: "周",
        },
        {
          value: "2",
          label: "月",
        },
      ],
      wayValue: "0",
      dimensionOptions: [
        {
          value: "0",
          label: "订单金额走势",
        },
        {
          value: "1",
          label: "扫码次数",
        },
        {
          value: "2",
          label: "设备部署走势",
        },
        {
          value: "3",
          label: "新增门店统计",
        },
      ],
      dimensionValue: "0",
      yesterdayOrder: "",
      yesterdayOrderCountYay: "",
      yesterdayOrderCountMam: "",
      yesterdayOrderMoneySum: "",
      yesterdayOrderMoneySumMam: "",
      yesterdayOrderMoneySumYay: "",
      yesterdayOrderRealPayMoneySum: "",
      yesterdayOrderRealPayMoneySumYay: "",
      yesterdayOrderRealPayMoneyMam: "",
      yesterdayNinetyNineOrderCount: "",
      yesterdayNinetyNineOrderMoneySumYay: "",
      yesterdayNinetyNineOrderCountMam: "",
      yesterdayRefundOrderMoneySum: "",
      yesterdayRefundOrderMoneySumYay: "",
      yesterdayRefundOrderMoneySumMam: "",
      yesterdayRefundOrderCount: "",
      yesterdayRefundOrderCountYay: "",
      yesterdayRefundOrderCountMam: "",
      yesterdayOrderDiscountMoneySum: "",
      yesterdayOrderDiscountMoneySumYay: "",
      yesterdayOrderDiscountMoneySumMam: "",
      device: "",
      deviceOnLineCount: "",
      deviceOffLineCount: "",
      deviceOnLineProportion: "",
      barData:[],
      option: [],
      cumulativeStaticsXData: ["订单数","订单金额","待支付","实付金额","优惠金额","退款数","99元订单"]
    };
  },
  methods: {
    /**
     * 初始化柱状图
     */
    initCumulativeStatic(data) {
      let myChart = echarts.init(document.getElementById("cumulativeStatics"))
      myChart.setOption({
        color: ["#8258FA"],
        title: {
          text: "累计统计",
          textStyle: {
            color: "#F6AD36"
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        tooltip: {
        trigger: 'axis',
        axisPointer: {
            type: 'shadow'
          }
        },
        xAxis: {
          type: 'value',
          boundaryGap: [0, 0.01]
        },
        yAxis: {
          type: 'category',
          data: this.cumulativeStaticsXData
        },
        series: [
          {
            data: data,
            type: "bar",
          },
        ]
      })
    },
    /**
     * 初始化饼图
     */
    initDeviceDistribute(data){
      let myChart = echarts.init(document.getElementById("deviceDistribute"))
      myChart.setOption({
        title: {
          text: "设备分布",
          left: 'center'
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'vertical',
          left: 'left',
          data: ["6口","9口","12口"]
        },
         series: [
          {
            name: '设备分布情况',
            type: 'pie',
            radius: '50%',
            data: data,
            emphasis: {
                itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
            }
          }
        ]
      })
    },
    /**
     * 初始化折线图
     */
    initCharts(data) {
      let myChart = echarts.init(document.getElementById("inline"));
      myChart.setOption({
        title: {
          text: "数据走势",
          textStyle: {
            color: "#F6AD36",
          },
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
          },
        },
        legend: {
          data: ['订单金额','设备部署','创建门店','扫码次数']
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: sevenDays(),
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            name: '订单金额',
            stack: '走势',
            data: data[0],
            type: "line"
          },
          {
            name: '设备部署',
            stack: '走势',
            data: data[1],
            type: "line"
          },
          {
            name: '创建门店',
            stack: '走势',
            data: data[2],
            type: "line"
          },
          {
            name: '扫码次数',
            stack: '走势',
            data: data[3],
            type: "line"
          },
        ],
      });
    },
    /**
     * 获取首页统计数据
     */
    index() {
      getIndexData().then(result => {
        this.yesterdayOrder = result.data.indexData.yesterdayOrderMap.yesterdayOrderCount;
        this.yesterdayOrderCountYay = result.data.indexData.yesterdayOrderMap.yesterdayOrderCountYay;
        this.yesterdayOrderCountMam = result.data.indexData.yesterdayOrderMap.yesterdayOrderCountMam;
        this.yesterdayOrderMoneySum = result.data.indexData.yesterdayOrderMap.yesterdayOrderMoneySum;
        this.yesterdayOrderMoneySumMam = result.data.indexData.yesterdayOrderMap.yesterdayOrderMoneySumMam;
        this.yesterdayOrderMoneySumYay = result.data.indexData.yesterdayOrderMap.yesterdayOrderMoneySumYay;
        this.yesterdayOrderRealPayMoneySum = result.data.indexData.yesterdayOrderMap.yesterdayOrderRealPayMoneySum;
        this.yesterdayOrderRealPayMoneySumYay =  result.data.indexData.yesterdayOrderMap.yesterdayOrderRealPayMoneySumYay;
        this.yesterdayOrderRealPayMoneyMam = result.data.indexData.yesterdayOrderMap.yesterdayOrderRealPayMoneyMam;
        this.yesterdayNinetyNineOrderCount = result.data.indexData.yesterdayOrderMap.yesterdayNinetyNineOrderCount;
        this.yesterdayNinetyNineOrderMoneySumYay = result.data.indexData.yesterdayOrderMap.yesterdayNinetyNineOrderMoneySumYay;
        this.yesterdayNinetyNineOrderCountMam = result.data.indexData.yesterdayOrderMap.yesterdayNinetyNineOrderCountMam;
        this.yesterdayRefundOrderMoneySum = result.data.indexData.yesterdayRefundOrderMap.yesterdayRefundOrderMoneySum;
        this.yesterdayRefundOrderMoneySumYay = result.data.indexData.yesterdayRefundOrderMap.yesterdayRefundOrderMoneySumYay;
        this.yesterdayRefundOrderMoneySumMam = result.data.indexData.yesterdayRefundOrderMap.yesterdayRefundOrderMoneySumMam;
        this.yesterdayRefundOrderCount = result.data.indexData.yesterdayRefundOrderMap.yesterdayRefundOrderCount;
        this.yesterdayRefundOrderCountYay = result.data.indexData.yesterdayRefundOrderMap.yesterdayRefundOrderCountYay;
        this.yesterdayRefundOrderCountMam =  result.data.indexData.yesterdayRefundOrderMap.yesterdayRefundOrderCountMam;
        this.yesterdayOrderDiscountMoneySum =result.data.indexData.yesterdayOrderMap.yesterdayOrderDiscountMoneySum;
        this.yesterdayOrderDiscountMoneySumYay = result.data.indexData.yesterdayOrderMap.yesterdayOrderDiscountMoneySumYay;
        this.yesterdayOrderDiscountMoneySumMam = result.data.indexData.yesterdayOrderMap.yesterdayOrderDiscountMoneySumMam;
        this.deviceOnLineCount = result.data.indexData.device.deviceOnLineCount;
        this.deviceOffLineCount = result.data.indexData.device.deviceOffLineCount;
        this.deviceOnLineProportion = result.data.indexData.device.deviceOnLineProportion;
        this.cumulativeOrderDiscountMoneySum = result.data.indexData.cumulativeOrderMap.cumulativeOrderDiscountMoneySum;
        this.cumulativeRefundOrderCount = result.data.indexData.cumulativeOrderMap.cumulativeRefundOrderCount;
        this.cumulativeOrderCount = result.data.indexData.cumulativeOrderMap.cumulativeOrderCount;
        this.cumulativeRefundOrderMoneySum = result.data.indexData.cumulativeOrderMap.cumulativeRefundOrderMoneySum;
        this.cumulativeNinetyNineOrderCount = result.data.indexData.cumulativeOrderMap.cumulativeNinetyNineOrderCount;
        this.cumulativeWaitPayOrderCount =result.data.indexData.cumulativeOrderMap.cumulativeWaitPayOrderCount;
        this.cumulativeOrderRealPayMoneySum = result.data.indexData.cumulativeOrderMap.cumulativeOrderRealPayMoneySum;
        this.cumulativeOrderMoneySum = result.data.indexData.cumulativeOrderMap.cumulativeOrderMoneySum;
        this.cumulativeWaitPayOrderMoneySum = result.data.indexData.cumulativeOrderMap.cumulativeWaitPayOrderMoneySum;
        let data = [];
        data.push(Number(this.cumulativeOrderCount))
        data.push(Number(this.cumulativeOrderMoneySum))
        data.push(Number(this.cumulativeWaitPayOrderMoneySum))
        data.push(Number(this.cumulativeOrderRealPayMoneySum))
        data.push(Number(this.cumulativeOrderDiscountMoneySum))
        data.push(Number(this.cumulativeRefundOrderMoneySum))
        data.push(Number(this.cumulativeNinetyNineOrderCount))
        this.initCumulativeStatic(data)
        let deviceData = [
          {
            name: '6口设备',
            value: result.data.indexData.device["6"],
            itemStyle: {color: '#DF0101'}
          },
          {
            name: '9口设备',
            value: result.data.indexData.device["9"],
            itemStyle: {color: '#0000FF'}
          },
          {
            name: '12口设备',
            value: result.data.indexData.device["12"],
            itemStyle: {color: '#00FF00'}
          }
        ]
        this.initDeviceDistribute(deviceData);
        this.getCharts(result);
      });
    },
    /**
     * 渲染折线图
     */
    getCharts(result) {
      let data = [];
      let zero = [0,0,0,0,0,0,0]
      let order = this.formatChartData(result.data.indexChartsData.order);
      order.length >0 ? data.push(order) : data.push(zero)
      let deploy = this.formatChartData(result.data.indexChartsData.deploy);
      deploy.length >0 ? data.push(deploy) : data.push(zero)
      let store = this.formatChartData(result.data.indexChartsData.store)
      store.length ? data.push(store) : data.push(zero)
      let scan = this.formatChartData(result.data.indexChartsData.store)
      scan.length ? data.push(scan) : data.push(zero)
      this.initCharts(data);
    },
    /**
     * 格式化折线图数据
     */
    formatChartData(data){
      let v = [];
      let days = sevenDays();
      days.forEach(d=>{
        data.forEach(o=>{
          if(o.xdata === d){
            v.push(o.ydata);
          }
        })
      })
      return v;
    }
  },
  created() {
    this.index();
  }
};
</script>
<style scoped>
  .index {
    width: 100%;
    height: 100%;
  }

  .yesterday-statics {
    width: 58%;
    float: left;
    padding: 0.3%;
  }

  .yesterday {
    width: 18%;
    height: 160px;
    display: block;
    float: left;
    margin: 1% 3% 1% 3%;
    background-color: #CEF6CE;
    border-radius: 10%;
  }
  .title {
    width: 60%;
    height: 15%;
    display: block;
    font-family: '微软雅黑';
    float: left;
    margin-right: 10%;
    font-weight: bold;
    color: #FF8000;
    line-height: 30px;
    font-size: 0.3rem;
  }
  .titleImg {
    margin-left: 8%;
  }
  .num {
    font-size: 0.4rem;
    width: 100%;
    height: 15%;
    display: block;
    float: left;
    color: #277bf1;
    margin-bottom: 5%;
  }

  .yesterday span {
    margin-top: 4%;
    display: block;
  }

  .pro1 span {
    text-align: left;
    width: 60%;
    margin-left: 20%;
    font-size: 0.3rem;
    color: #0B2161;
  }

  img {
    width: 18%;
    height: 20%;
    float: left;
    display: block;
    margin-top: 4%;
    margin-left: 2%;
  }

  .pro2 span {
    text-align: left;
    width: 80%;
    margin-left: 20%;
    font-size: 0.3rem;
    color: #0B2161;
  }

  .pro1 img {
    width: 10%;
    height: 10%;
    margin-left: 20%;
    margin-top: 0.3%;
  }

  .pro2 img {
    width: 10%;
    height: 10%;
    margin-left: 20%;
    margin-top: 0.3%;
  }
  #cumulativeStatics{
    padding: auto;
    width: 40%;
    height: 40%;
    float: right;
  }
  .myEcharts {
    display: block;
    float: left;
    width: 98%;
    height: 50%;
    margin-top: 3%;
    margin-left: 1%;
  }
  #inline {
    width: 60%;
    margin-left: 5%;
    float: left;
    height: 100%;
    border-radius: 1%;
  }
  #deviceDistribute{
    float: left;
    width: 30%;
    height: 100%;
    border-radius: 1%;
  }
</style>



// WEBPACK FOOTER //
// src/pages/index/index.vue